import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { styled } from 'themes';
import { Img } from 'components';
import { device } from 'themes/media-queries';
import { useTranslation } from 'react-i18next';

const Team = () => {
  const [t] = useTranslation();
  const data = useStaticQuery(graphql`
    query TeamQuery {
      allStrapiEmployee(sort: { order: ASC, fields: Name }) {
        edges {
          node {
            id
            name
            position
            profile_image {
              childImageSharp {
                fluid(maxHeight: 640, quality: 90) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  `);

  const employees = data.allStrapiEmployee.edges;
  return (
    <Section>
      <Heading>{t('section--team.heading')}</Heading>
      <List>
        {employees.map(employee => {
          const { id, name, position, profile_image } = employee.node;
          return (
            <Card key={id} boxShadow={3}>
              <Header>
                <h3>{name}</h3>
                <p>{position}</p>
              </Header>

              <Image
                fluid={profile_image && profile_image.childImageSharp.fluid}
              />
            </Card>
          );
        })}
      </List>
    </Section>
  );
};

const Section = styled.section`
  grid-column: center-start / center-end;
`;

const Heading = styled.h2`
  margin-bottom: 2rem;
`;

const List = styled.div`
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(auto-fit, minmax(215px, 355px));
  grid-auto-rows: 1fr;

  margin-bottom: 10rem;

  @media ${device.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Card = styled.div`
  background-color: white;
  box-shadow: 0 2rem 5rem rgba(0, 0, 0, 0.2);
`;

const Header = styled.div`
  padding: 2.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.silver};

  & > p {
    color: ${({ theme }) => theme.colors.battleshipGrey};
  }

  @media ${device.mobileL} {
    padding: 1.5rem;

    & > h3 {
      font-size: 1.7rem;
    }
  }
`;

const Image = styled(Img)`
  object-fit: cover;
  height: 100%;
  max-height: 40rem;

  & img {
    object-position: center top !important;
  }

  @media ${device.mobileL} {
    max-height: 20rem;
  }
`;

export default Team;
